import type { StripePaymentSliceState } from './types';

export const moduleName = 'stripePayments';

export const initialSliceState: StripePaymentSliceState = {
  checkoutIntent: null,
};

export enum StripeThemes {
  Stripe = 'stripe',
  Night = 'night',
  Flat = 'flat',
}

export enum StripePaymentCreationMethods {
  Manual = 'manual',
}

export enum StripeAddressElementModes {
  Billing = 'billing',
  Shipping = 'shipping',
}

export enum StripePaymentElementLayouts {
  Tabs = 'tabs',
  Accordion = 'accordion',
  Auto = 'auto',
}
